import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import type { Product } from '../data/products';

const productHref = (product: Product) => {
  if (product.division === 'Animal Nutrition' && product.slug === 'cattle-feed') return '/animal-nutrition/cattle-feed';
  if (product.division === 'Animal Nutrition' && product.slug === 'pig-feed') return '/animal-nutrition/pig-feed';
  if (product.division === 'Animal Nutrition') return `/products/${product.slug}`;
  if (product.division === 'Edible Oils') return `/edible-oils/${product.slug}`;
  return '/contact';
};

const productLabel = (product: Product) => {
  if (product.division === 'Edible Oils') return 'Edible Oils';
  return product.category;
};

const productTitle = (product: Product) => {
  if (product.division === 'Edible Oils') return `${product.name} (Coming Soon)`;
  return product.name;
};

export function ProductCard({ product }: { product: Product }) {
  return (
    <Link
      to={productHref(product)}
      className="group flex h-full min-w-0 flex-col overflow-hidden rounded-[1.25rem] border border-forest/10 bg-white shadow-soft transition hover:-translate-y-1 hover:shadow-soft focus-visible:outline focus-visible:outline-3 focus-visible:outline-offset-4 focus-visible:outline-forest"
      aria-label={`${productTitle(product)} — ${product.enquiryCTA}`}
    >
      <div className="relative bg-gradient-to-br from-tint to-cream p-3 sm:p-4">
        <img src={product.image} alt={`${product.name} packaging and product information`} loading="lazy" decoding="async" width={400} height={320} className="h-56 w-full rounded-[1rem] object-contain sm:h-64" />
      </div>
      <div className="flex flex-1 flex-col p-5 sm:p-6">
        <p className="text-[0.68rem] font-black uppercase tracking-[0.16em] text-gold sm:text-xs sm:tracking-[0.2em]">{productLabel(product)}</p>
        <h3 className="mt-3 text-xl font-black text-ink sm:text-2xl">{productTitle(product)}</h3>
        <p className="mt-3 text-sm leading-6 text-charcoal/70 sm:text-base sm:leading-7">{product.shortDescription}</p>
        <div className="mt-5 grid gap-2">
          {product.keyBenefits.slice(0, 3).map((benefit) => (
            <span key={benefit} className="inline-flex gap-2 text-sm leading-6 text-charcoal/75"><CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-forest" /> {benefit}</span>
          ))}
        </div>
        <span className="mt-6 inline-flex items-center gap-2 font-black text-forest group-hover:text-ink">
          {product.enquiryCTA} <ArrowRight className="h-4 w-4" />
        </span>
      </div>
    </Link>
  );
}
